import { graphql } from "gatsby";
import React from "react";
import { CompletedProjects } from "../CompletedProjects/CompletedProjects";
import "./styles.css";

const ShopEquipmentPOSStandsProjects = ({ title, examples }) => {
  return (
    <div className="ShopEquipmentPOSStandsProjects">
      <CompletedProjects title={title} examples={examples} />
    </div>
  );
};

ShopEquipmentPOSStandsProjects.getLivePreviewData = ({ data, getAsset }) => ({
  shopEquipmentPOSStandsProjects: {
    ...data.shopEquipmentPOSStandsProjects,
    examples: data.shopEquipmentPOSStandsProjects.examples.map(example => ({
      ...example,
      photo: getAsset(example.photo).url,
    })),
  },
});

const shopEquipmentPOSStandsProjectsQuery = graphql`
  fragment ShopEquipmentPOSStandsProjectsFragment on MarkdownRemarkFrontmatter {
    shopEquipmentPOSStandsProjects {
      title
      examples {
        photo {
          childImageSharp {
            fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        alt
        title
        description
      }
    }
  }
`;

export { ShopEquipmentPOSStandsProjects, shopEquipmentPOSStandsProjectsQuery };
